import React from 'react'

function FacebookSvg() {
  return (
    <>
      <svg
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='16' cy='16' r='15.5' fill='white' stroke='#D1DEEE' />
        <path
          d='M17 24V17H20L20.5 14H17V12.5C17 11.5 17.501 11 18.5 11H20V8C19.5 8 18.38 8 17.5 8C15 8 14 9.5 14 12V14H11V17H14V24H17Z'
          fill='#0E1F33'
        />
      </svg>
    </>
  )
}

export default FacebookSvg
